import React, { useState, useEffect } from 'react';

const FileViewer = ({ file, contextId, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFileDetails = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const url = new URL(`${process.env.REACT_APP_API_URL}/api/file/${file.id}`);
        if (contextId) {
          url.searchParams.append('contextId', contextId);
        }

        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          // Open the source URL in a new tab
          window.open(data.data.source_url, '_blank');
          onClose(); // Close the modal after opening the URL
        } else {
          throw new Error('Failed to fetch file details');
        }
      } catch (error) {
        console.error('Error fetching file:', error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFileDetails();
  }, [file.id, contextId]);

  // Only show loading or error states
  if (!isLoading && !error) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6">
        {isLoading ? (
          <div className="flex justify-center items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : error ? (
          <div className="text-red-500 text-center">
            {error}
            <button 
              onClick={onClose}
              className="mt-4 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Close
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FileViewer; 